import { CommunicationType } from './fu-unit';
export class CommunicationProtocol {
    id?: string;
    name: string;
    type: ProtocolType;
    boardType: CommunicationType;
    createdAt?: Date;
}

export enum ProtocolType {
    UNDEFINED,
    POLLING,
    RECEIVER,
    TRANSMITER,
    RESPONDER,
}
